module.exports = __webpack_public_path__ + "img/arrow-circle-up.b93b93ce.svg";